import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import contratoService from "@/services/contrato";
export function setContratoSincronizando(_ref, _ref2) {
  var commit = _ref.commit;
  var contratoId = _ref2.contratoId,
    token = _ref2.token;
  commit("setContratoSincronizando", {
    contratoId: contratoId,
    token: token
  });
}
export function removeContratoSincronizando(_ref3, contratoId) {
  var commit = _ref3.commit;
  commit("removeContratoSincronizando", contratoId);
}
export function clearContratosSincronizando(_ref4) {
  var commit = _ref4.commit;
  commit("clearContratosSincronizando");
}

/**
 * Checa o status da sincronização de um contrato.
 * @param {Object} context o contexto do Vuex.
 * @param {string} contratoId o ID do contrato.
 * @returns {Promise<string|null>} o status do contrato.
 */
export function checarStatusContratoSincronizando(_x, _x2) {
  return _checarStatusContratoSincronizando.apply(this, arguments);
}
function _checarStatusContratoSincronizando() {
  _checarStatusContratoSincronizando = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref5, contratoId) {
    var state, commit, token, _yield$contratoServic, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          state = _ref5.state, commit = _ref5.commit;
          token = state.contratosSincronizando[String(contratoId)];
          if (token) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return contratoService.checkStatus(token);
        case 2:
          _yield$contratoServic = _context.v;
          data = _yield$contratoServic.data;
          if (data.status !== "PENDING") {
            commit("removeContratoSincronizando", contratoId);
          }
          return _context.a(2, data.status);
        case 3:
          _context.p = 3;
          _t = _context.v;
          commit("removeContratoSincronizando", contratoId);
          throw _t;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _checarStatusContratoSincronizando.apply(this, arguments);
}